import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Spinner } from 'react-bootstrap';
import Filter from './components/filter/filter';
import ReportContainer from './components/report-container/report-container';

import {useHistory} from "react-router-dom";
import ReportsService from "../../../../services/reports-service";


import './maker-reports-module.scss';

const MakerReportsModule = () => {
    const [items, setItems] = useState([]);
    const [filteredItems, setFilteredItems] = useState([]);
    const [loading, setLoading] = useState(true);

    const reportsService = new ReportsService();
    const history = useHistory();

    useEffect(() => {
        const getSecurities = async () => {
          try {
            const result = await reportsService.getSecurities();
            setItems(result.items);
            console.log('maker result', result);
          } catch (error) {
            console.error('Fetching error:', error);
            history.push(`/internal-server-error`);
          } finally {
            setLoading(false);
          }
        }
        getSecurities();
      }, []);

    const handleFilterChange = (filters) => {
        const { status, paymentDate, issuers } = filters;

        const filtered = items.filter((item) => {
            const matchesStatus = status.length ? status.includes(item.status) : true;
            const matchesPaymentDate = paymentDate ? item.paymentDate === paymentDate : true;
            const matchesIssuer = issuers.length ? issuers.includes(item.issuer) : true;

            return matchesStatus && matchesPaymentDate && matchesIssuer;
        });

        setFilteredItems(filtered);
    };

    return (
        <Container fluid className="maker-reports-module-container">
            {loading ? (
                <div className="loading-container">
                    <Spinner animation="border" role="status">
                        <span className="sr-only">Loading...</span>
                    </Spinner>
                </div>
            ) : (
                <Row>
                    <Col xs={12} md={3} className="panel">
                        <Filter 
                            items={items} 
                            filter={{ status: [], paymentDate: '', issuers: [] }} 
                            onFilterChange={handleFilterChange} 
                        />
                    </Col>
                    <Col xs={12} md={9}>
                        <ReportContainer items={filteredItems} />
                    </Col>
                </Row>
            )}
        </Container>
    );
};

export default MakerReportsModule;